module.exports = __webpack_public_path__ + "static/media/charlotte-moroz-civil-war-pigeons-mobile-top-reduced.8029d871.webp";